// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { ProgramScoringStatus, ScoringSnapshotResponse } from "./types/scoringStatusTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclScoringStatusApi = createApi({
    reducerPath: "cclScorintStatusApi",
    tagTypes: [],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getProgramScoringStatus: builder.query<ProgramScoringStatus, number>({
            query: (eskey) => `ccl-access2/ScoringStatus/program/${eskey}`,
        }),
        getScoringSnapshot: builder.query<ScoringSnapshotResponse, void>({
            query: () => "ccl-access2/ScoringStatus/snapshot",
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetProgramScoringStatusQuery,
    useLazyGetScoringSnapshotQuery,
} = cclScoringStatusApi;
